export const Data = [
    {
        id: 1,
        title: "WORSHIP SERVICE",
        body: "Sundays | 8:30am",
        image:"/images/one (6).jpg"
    },
    {
        id: 2,
        title: "BIBLE STUDY",
        body: " Wednesdays | 5:00pm",
        image:"/images/one (2).jpg"

    },
    {
        id: 3,
        title: "MONTHLY VIGIL",
        body: " Third Fridays | 10:00pm",
        image:"/images/one (15).jpg"

    },
    
];
export const Message =[
    {
        id:1,
        img:"https://m.media-amazon.com/images/G/01/sp-marketing-toolkit/guides/design/iconography/Mobile_App.svg",
        theme:"Christian Home Series",
        title:"Christian Home",
        description:"What is Christian Home? It has to do with the father, the mother, the children, and the way they all relate, and what gives birth to a Christian home is marriage. Marriage is a lifelong journey that requires adequate preparation.\nThe foundation of every structure that will last is very important. The type of structure will determine the type of foundation. The problem in so many families today is foundational. A lot of people today just enter into a marriage they did not prepare for. They don't even know what it is they just enter it, and they are causing trouble. If you want to understand a thing you go to the foundation of that thing. How much preparation did you make before entering that marriage? if there is no preparation then you are prepared for a failed home.",
        timestamp:"Feb 20, 2023",
        profile:"/images/team-1.jpg",
        preacher:"/log2/man sepcam image.png",
        icon:"/logs/video-filled.png"

    },
    {
        id:2,
        img:"https://m.media-amazon.com/images/G/01/sp-marketing-toolkit/guides/design/iconography/Mobile_App.svg",
        theme:"Christian Home Series",
        title:"Christian Home",
        description:"What is Christian Home? It has to do with the father, the mother, the children, and the way they all relate, and what gives birth to a Christian home is marriage. Marriage is a lifelong journey that requires adequate preparation.\nThe foundation of every structure that will last is very important. The type of structure will determine the type of foundation. The problem in so many families today is foundational. A lot of people today just enter into a marriage they did not prepare for. They don't even know what it is they just enter it, and they are causing trouble. If you want to understand a thing you go to the foundation of that thing. How much preparation did you make before entering that marriage? if there is no preparation then you are prepared for a failed home.",
        timestamp:"Feb 20, 2023",
        profile:"/images/team-1.jpg",
        preacher:"/log2/man sepcam image.png",
        icon:"/logs/video-filled.png"

    },
    {
        id:3,
        img:"https://m.media-amazon.com/images/G/01/sp-marketing-toolkit/guides/design/iconography/Mobile_App.svg",
        theme:"Christian Home Series",
        title:"Christian Home",
        description:"What is Christian Home? It has to do with the father, the mother, the children, and the way they all relate, and what gives birth to a Christian home is marriage. Marriage is a lifelong journey that requires adequate preparation.\nThe foundation of every structure that will last is very important. The type of structure will determine the type of foundation. The problem in so many families today is foundational. A lot of people today just enter into a marriage they did not prepare for. They don't even know what it is they just enter it, and they are causing trouble. If you want to understand a thing you go to the foundation of that thing. How much preparation did you make before entering that marriage? if there is no preparation then you are prepared for a failed home.",
        timestamp:"Feb 20, 2023",
        profile:"/images/team-1.jpg",
        preacher:"/log2/man sepcam image.png",
        icon:"/logs/video-filled.png"

    },
    {
        id:4,
        img:"https://m.media-amazon.com/images/G/01/sp-marketing-toolkit/guides/design/iconography/Mobile_App.svg",
        theme:"Christian Home Series",
        title:"Christian Home",
        description:"What is Christian Home? It has to do with the father, the mother, the children, and the way they all relate, and what gives birth to a Christian home is marriage. Marriage is a lifelong journey that requires adequate preparation.\nThe foundation of every structure that will last is very important. The type of structure will determine the type of foundation. The problem in so many families today is foundational. A lot of people today just enter into a marriage they did not prepare for. They don't even know what it is they just enter it, and they are causing trouble. If you want to understand a thing you go to the foundation of that thing. How much preparation did you make before entering that marriage? if there is no preparation then you are prepared for a failed home.",
        timestamp:"Feb 20, 2023",
        profile:"/images/team-1.jpg",
        preacher:"/log2/man sepcam image.png",
        icon:"/logs/video-filled.png"

    },
    {
        id:5,
        img:"https://m.media-amazon.com/images/G/01/sp-marketing-toolkit/guides/design/iconography/Mobile_App.svg",
        theme:"Christian Home Series",
        title:"Christian Home",
        description:"What is Christian Home? It has to do with the father, the mother, the children, and the way they all relate, and what gives birth to a Christian home is marriage. Marriage is a lifelong journey that requires adequate preparation.\nThe foundation of every structure that will last is very important. The type of structure will determine the type of foundation. The problem in so many families today is foundational. A lot of people today just enter into a marriage they did not prepare for. They don't even know what it is they just enter it, and they are causing trouble. If you want to understand a thing you go to the foundation of that thing. How much preparation did you make before entering that marriage? if there is no preparation then you are prepared for a failed home.",
        timestamp:"Feb 20, 2023",
        profile:"/images/team-1.jpg",
        preacher:"/log2/man sepcam image.png",
        icon:"/logs/video-filled.png"

    },
    {
        id:6,
        img:"https://m.media-amazon.com/images/G/01/sp-marketing-toolkit/guides/design/iconography/Mobile_App.svg",
        theme:"Christian Home Series",
        title:"Christian Home",
        description:"What is Christian Home? It has to do with the father, the mother, the children, and the way they all relate, and what gives birth to a Christian home is marriage. Marriage is a lifelong journey that requires adequate preparation.\nThe foundation of every structure that will last is very important. The type of structure will determine the type of foundation. The problem in so many families today is foundational. A lot of people today just enter into a marriage they did not prepare for. They don't even know what it is they just enter it, and they are causing trouble. If you want to understand a thing you go to the foundation of that thing. How much preparation did you make before entering that marriage? if there is no preparation then you are prepared for a failed home.",
        timestamp:"Feb 20, 2023",
        profile:"/images/team-1.jpg",
        preacher:"/log2/man sepcam image.png",
        icon:"/logs/video-filled.png"

    },

];

export  const Page =[
    {
        id:1,
        img:"https://m.media-amazon.com/images/G/01/sp-marketing-toolkit/guides/design/iconography/Mobile_App.svg",
        theme:"Christian Home Series",
        title:"Christian Home",
        description:"What is Christian Home? It has to do with the father, the mother, the children, and the way they all relate, and what gives birth to a Christian home is marriage. Marriage is a lifelong journey that requires adequate preparation.\nThe foundation of every structure that will last is very important. The type of structure will determine the type of foundation. The problem in so many families today is foundational. A lot of people today just enter into a marriage they did not prepare for. They don't even know what it is they just enter it, and they are causing trouble. If you want to understand a thing you go to the foundation of that thing. How much preparation did you make before entering that marriage? if there is no preparation then you are prepared for a failed home.",
        timestamp:"Feb 20, 2023",
        profile:"/images/team-1.jpg",
        preacher:"/log2/man sepcam image.png",
        icon:"/logs/video-filled.png"

    },
]
